module.exports = __webpack_public_path__ + "static/ead-01-863fa28946c4e2c826767090b124d33b.jpg";